<template>
  <Page>
    <section class="stat-carrier-container">
      <Announce style="margin-top: 8px;" />
      <Breadcrumb title="船司数据" />
      <div class="stat-carrierbi">
        <iframe
          ref="iframeRef"
          allowfullscreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          :src="BIUrl"
          style="width: 100%; height: 100%;"
          scrolling="auto"
          frameborder="0"
        >
        </iframe>
      </div>
    </section>
  </Page>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import Page from '@/components/page';
  import Announce from '@/components/announce';
  import Breadcrumb from '@/components/breadcrumb';

  const BIUrl = 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=17dd861e-14eb-41fb-8035-73a69b431f18&accessTicket=0b4039bb-64cd-4168-b0f6-3e13a05d8fde&dd_orientation=auto';
</script>

<style scoped lang="less">
@import "./index.less";
</style>
